<script setup lang="ts">
/**
 * Шапка приватной части: кнопка сворачивания сайдбара, заголовок текущей
 * страницы, меню пользователя справа.
 *
 * Заголовок по умолчанию берётся из `meta.title` — того же источника, что и
 * `document.title` в `guards.ts`. Экран, которому нужен динамический заголовок
 * (например `/users/:id` с именем пользователя), подставляет свой через слот
 * `title`, не заводя параллельного механизма.
 */
import { useRoute } from 'vue-router'
import { Separator } from '@/components/ui/separator'
import { SidebarTrigger } from '@/components/ui/sidebar'
import UserMenu from './UserMenu.vue'

const route = useRoute()
</script>

<template>
  <header
    class="sticky top-0 z-10 flex h-14 shrink-0 items-center gap-2 border-b bg-background/95 px-4 backdrop-blur supports-[backdrop-filter]:bg-background/60"
  >
    <SidebarTrigger class="-ml-1" />
    <!--
      `my-auto`, а не `self-center`. Реестр вешает на разделитель
      `data-[orientation=vertical]:self-stretch`, и этот селектор специфичнее
      (класс + атрибут), чем обычный `self-center`, — переопределить его классом
      той же «силы» нельзя, и полоска прилипает к верхнему краю шапки.
      Авто-margin по поперечной оси по спецификации выигрывает у `align-self`
      вообще, поэтому центрирование получается без гонки специфичностей.
    -->
    <Separator orientation="vertical" class="mr-1 my-auto h-4" />

    <div class="min-w-0 flex-1 truncate text-sm font-medium">
      <slot name="title">{{ route.meta.title ?? '' }}</slot>
    </div>

    <UserMenu />
  </header>
</template>
